"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Days = exports.ResourceType = exports.PresentationState = exports.PresentationType = void 0;
var PresentationType;
(function (PresentationType) {
    PresentationType["PRESENTATION"] = "PRESENTATION";
    PresentationType["PLAYLIST"] = "PLAYLIST";
    PresentationType["TEMPLATE"] = "TEMPLATE";
})(PresentationType = exports.PresentationType || (exports.PresentationType = {}));
var PresentationState;
(function (PresentationState) {
    PresentationState["PUBLISHED"] = "PUBLISHED";
    PresentationState["PLANNED_PUBLISHING"] = "PLANNED PUBLISHING";
    PresentationState["DRAFT"] = "DRAFT";
})(PresentationState = exports.PresentationState || (exports.PresentationState = {}));
var ResourceType;
(function (ResourceType) {
    ResourceType["PRESENTATION"] = "PRESENTATION";
    ResourceType["PLAYLIST"] = "PLAYLIST";
    ResourceType["PLAYER"] = "PLAYER";
    ResourceType["INTEGRATION"] = "INTEGRATION";
    ResourceType["FOLDER"] = "FOLDER";
    ResourceType["MEDIA"] = "MEDIA";
    ResourceType["EVENT"] = "EVENT";
    ResourceType["OAUTH2CLIENT"] = "OAUTH2CLIENT";
    ResourceType["METADATA"] = "METADATA";
    ResourceType["APPTEMPLATE"] = "APPTEMPLATE";
})(ResourceType = exports.ResourceType || (exports.ResourceType = {}));
var Days;
(function (Days) {
    Days[Days["Monday"] = 0] = "Monday";
    Days[Days["Tuesday"] = 1] = "Tuesday";
    Days[Days["Wednesday"] = 2] = "Wednesday";
    Days[Days["Thursday"] = 3] = "Thursday";
    Days[Days["Friday"] = 4] = "Friday";
    Days[Days["Saturday"] = 5] = "Saturday";
    Days[Days["Sunday"] = 6] = "Sunday";
})(Days = exports.Days || (exports.Days = {}));
